const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'domain', label: 'Site', sortable: false },
    { key: 'url', label: 'Page', sortable: false, width: '30%' },
    { key: 'code', label: 'Code', sortable: false, width: '30%' },
    { key: 'level', label: 'Level', sortable: false },
    { key: 'type', label: 'Type', sortable: false },
    { key: 'created_at', label: 'Detected Date', sortable: true },
    { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'domain', label: '사이트', sortable: false },
    { key: 'url', label: '페이지', sortable: false, width: '30%' },
    { key: 'code', label: '코드', sortable: false, width: '30%' },
    { key: 'level', label: '레벨', sortable: false },
    { key: 'type', label: '타입', sortable: false },
    { key: 'created_at', label: '탐지시각', sortable: true },
    { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'domain', label: 'サイト', sortable: false },
    { key: 'url', label: 'ページ', sortable: false, width: '30%' },
    { key: 'code', label: 'コード', sortable: false, width: '30%' },
    { key: 'level', label: 'レベル', sortable: false },
    { key: 'type', label: 'タイプ', sortable: false },
    { key: 'created_at', label: '検出日', sortable: true },
    { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const fields = { i18n_fields }

export default fields